import React, { useState } from "react";
import ReceiptScanner from "../scanner/receipt-scanner";

export default function StepZero({ data, setData, onNext }) {
  const [choiceMade, setChoiceMade] = useState(false);

  const handleTextExtracted = (text) => {
    const lines = text.toLowerCase().split("\n");
    let total = "";
    let sst = "";

    const totalKeywords = [
      "grand total",
      "total amount",
      "amount total",
      "total",
      "subtotal",
      "amount due",
      "net total",
    ];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      for (let keyword of totalKeywords) {
        if (line.includes(keyword)) {
          // Try to find number in same or next line
          const match =
            line.match(/(\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+\.\d{2})/) ||
            lines[i + 1]?.match(/(\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+\.\d{2})/);
          if (match) {
            total = parseFloat(match[0].replace(/,/g, ""));
          }
        }
      }

      if (!sst) {
        const sstMatch = line.match(/(sst|tax)[\s:-]*([\d,]+\.\d{2})/i);
        if (sstMatch) {
          sst = parseFloat(sstMatch[2].replace(/,/g, ""));
        }
      }
    }

    // Improved meal line detection
    const mealRegex = /^.*?([a-z ]{2,})\s+(\d{0,2}\.?\d{1,2})[^0-9]*$/gm;
    const meals = [];
    let match;
    while ((match = mealRegex.exec(text.toLowerCase())) !== null) {
      const name = match[1].trim();
      const price = parseFloat(match[2]);
      if (
        name.includes("total") ||
        name.includes("tax") ||
        name.includes("subtotal") ||
        isNaN(price)
      )
        continue;
      meals.push({ name, price, guests: [] });
    }

    setData((prev) => ({
      ...prev,
      total,
      sst,
      meals,
    }));

    if (total && meals.length > 0) {
      onNext?.();
    } else {
      alert("Could not detect total or meals");
    }
  };

  const handleChoice = (wantScan) => {
    setData({ ...data, wantScan });
    setChoiceMade(true);
    if (!wantScan) {
      onNext?.();
    }
  };

  return (
    <div>
      {!choiceMade ? (
        <>
          <h2>Would you like to scan a receipt?</h2>
          <button onClick={() => handleChoice(true)} style={btnStyle}>
            📷 Scan Receipt
          </button>
          <button
            onClick={() => handleChoice(false)}
            style={{ ...btnStyle, backgroundColor: "#aaa" }}
          >
            🚫 Skip Scanning
          </button>
        </>
      ) : data.wantScan ? (
        <>
          <h2>Scan Receipt</h2>
          <ReceiptScanner onTextExtracted={handleTextExtracted} />
        </>
      ) : (
        <h2>Proceeding without scanning...</h2>
      )}
    </div>
  );
}

const btnStyle = {
  padding: "0.75rem 1.5rem",
  margin: "0.5rem",
  backgroundColor: "#4a90e2",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};
